/**
 * Plates and dies — one thing wearing two names, on the web side too.
 *
 * The backend keeps this distinction in one dataclass (`services/tooling.py`)
 * and builds every route twice from it. The screens do the same: one tracking
 * board and one register, configured by whichever of these two objects they are
 * handed. Adding a third kind of bought-in tooling is a third entry here plus
 * its routes — no new screen.
 *
 * `plural` is both the API prefix for the board and the key the board and the
 * register answer under, which is why one field carries it.
 */

const tooling = (config) => ({
  ...config,
  boardPath: `/${config.plural}`,
  registerPath: `/${config.kind}-register`,
  trackingApi: `/${config.plural}/tracking`,
  markApi: (row, action) =>
    `/${config.plural}/orders/${row.order_uuid}/items/${row.line_item_id}/mark-${action}`,
  registerApi: `/${config.kind}-register`,
  statusField: `${config.kind}_status`,
  orderedAtField: `${config.kind}_ordered_at`,
  orderedByField: `${config.kind}_ordered_by_name`,
  receivedAtField: `${config.kind}_received_at`,
  receivedByField: `${config.kind}_received_by_name`,
});

export const PLATE = tooling({
  kind: 'plate',
  label: 'Plate',
  labelPlural: 'Plates',
  plural: 'plates',
  boardTitle: 'Plate Tracking',
  registerTitle: 'Plate Register',
  emptyBoard: 'No plates waiting to be ordered',
  emptyRegister: 'No plates on the rack',
});

export const DIE = tooling({
  kind: 'die',
  label: 'Die',
  labelPlural: 'Dies',
  plural: 'dies',
  boardTitle: 'Die Tracking',
  registerTitle: 'Die Register',
  emptyBoard: 'No dies waiting to be ordered',
  emptyRegister: 'No dies on the rack',
});
